import { z } from 'zod/v4'

// Configuration for how linked items are displayed
const DisplayConfigSchema = z.object({
  type: z.enum(['list', 'grid', 'table', 'cards']).default('list'),
  showCount: z.boolean().default(true),
  showActions: z.boolean().default(true),
  itemsPerPage: z.number().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
})

// Configuration for navigation behavior
const NavigationConfigSchema = z.object({
  openInNewTab: z.boolean().default(false),
  preserveContext: z.boolean().default(true),
  showBreadcrumbs: z.boolean().default(true),
})

// Configuration for relationship filtering
const FilterConfigSchema = z.object({
  enabled: z.boolean().default(false),
  fields: z.array(z.string()).optional(),
  defaultFilters: z.record(z.string(), z.any()).optional(),
})

// Column schema for link blocks (similar to form)
const ColumnSchema = z.object({
  colSpan: z.number().optional(),
  // the field handle to display
  field: z.string(),
  // the extension to the root query
  subQuery: z.any(),
  // whether this field is editable (for link blocks, typically false)
  editable: z.boolean().default(false),
  // display configuration for this specific field
  display: z
    .object({
      showLabel: z.boolean().default(true),
      showValue: z.boolean().default(true),
      format: z
        .enum(['text', 'date', 'currency', 'percentage', 'badge'])
        .optional(),
    })
    .optional(),
})

// Row schema for link blocks (similar to form)
const RowSchema = z.object({
  columns: z.array(ColumnSchema),
})

export const LinkConfigSchema = z.object({
  type: z.literal('link'),
  // Relationship configuration
  relationshipLinkId: z.string(),

  // Layout configuration (similar to form)
  rows: z.array(RowSchema),

  // Display configuration
  display: DisplayConfigSchema.optional(),

  // Navigation configuration
  navigation: NavigationConfigSchema.optional(),

  // Filter configuration
  filters: FilterConfigSchema.optional(),

  // Query configuration for fetching linked data
  query: z.any().optional(), // TODO: Define proper query schema
})
